"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function YourPrivacyMatters() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="relative min-h-screen w-full overflow-hidden bg-primary">
      {}
      <div className="fixed inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/monochrome_cityscape_privacy.png)"
    }}>
        <div className="surface-overlay absolute inset-0" />
      </div>

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-16">
        <Card ref={ref} className={`card max-w-2xl transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <CardContent className="flex gap-4 p-8">
            {}
            <div className={`h-full w-1 flex-shrink-0 rounded-full bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-2 opacity-0"}`} />

            {}
            <div className="flex flex-col gap-4">
              <h2 className="font-display text-3xl font-bold text-foreground-light md:text-4xl">
                Your Privacy Matters
              </h2>
              <p className="text-base leading-relaxed text-foreground-light md:text-lg">
                We are committed to protecting your personal information and ensuring your data remains secure. 
                Your privacy is paramount to us, and we implement industry-leading practices to safeguard every interaction. 
                Trust is the foundation of our service, and we honor that trust by maintaining the highest standards of confidentiality.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}